import React, { useCallback, useRef, useState, useEffect } from "react";
import { Box } from "@chakra-ui/layout";
import "./menu-bar.css";
import backIcon from "../lib/assets/icon--back.svg";
import logo from "../lib/assets/scratch-logo.svg";
import embeddedIcon from '../lib/assets/embeddedIcon.svg';
import databaseIcon from '../lib/assets/databaseIcon.png'
import buildIcon from '../lib/assets/icon--build.png';
import helpIcon from '../lib/assets/icon--tutorials.svg';
import LanguageMenuItem from "./language-menu-item";
import FileMenuItem from './file-menu-item';
import { getMobileOS, isWebview } from '../lib/supported-browser';
import AccountCancelationModal from './accountCancelationModal/index.jsx';
import ToolboxMenuItem from './toolbox-menu-item.jsx';
import AccountNav from './account-nav';
import WorkMenuItem from './work-menu-item.jsx';
import AImenuItem from './ai-menu-item.jsx'
// import { useIntl } from "react-intl";
import { useIntl, FormattedMessage } from 'react-intl';
// import { userState } from "../reducers/user-state.js";
// import {connect} from 'react-redux';
// import {compose} from 'redux';
// import {injectIntl} from 'react-intl';

// interface MenuBarProps {
//   handleClickLogo: () => void;
//   languageMenuOpen?: boolean,
//   fs: () => object
// }
const MenuBar = (fs) => {
    // const MenuBar: React.FC<MenuBarProps> = ({
    //   languageMenuOpen
    // }) => {
    // const loginState = useSelector((state: RootState) => state.userState.loginState);
    // // console.log(loginState)
    // console.log(getIsLogged(loginState));
    // 获取是否登录状态
    const [loginState, setLoginState] = useState<string>(localStorage.getItem('token'));
    // console.log(loginState, 'loginState')

    const accountCancelationModalRef = useRef(null);
    // 项目名称
    const workMenuItemRef = React.createRef();
    // 点击图标跳转
    const handleClickLogo = useCallback(() => {
        const settings = JSON.parse(localStorage.getItem('settings'))
        if (settings.languageId === 'zh-cn') {
            window.open('https://www.matatalab.com', '_blank');
        } else {
            window.open('https://en.matatalab.com/', '_blank');
        }
        // else if (settings.languageId === 'ja') {
        //     window.open('https://matatalab.jp', '_blank');
        // } 
    }, []);
    // const handleChange = useCallback(() => {
    //     // 处理变更事件的逻辑
    // }, []);
    // const onClickLanguage = useCallback(() => {

    // }, [])
    // const onRequestCloseLanguage = useCallback(() => {

    // }, [])

    const handleClickFile = () => {
        // 处理点击文件的逻辑
    };

    const handleRequestCloseFile = () => {
        // 处理关闭文件的逻辑
    };

    const handleClickSave = () => {
        // 处理保存的逻辑
    };

    const handleClickSaveAsCopy = () => {
        // 处理另存为副本的逻辑
    };
    // 点击嵌入式机器
    const handleClickAIProject = () => {
        localStorage.setItem('routerMeunId', 'AIProject')
        window.location.href = window.location.origin
    }
    // 点击数据库
    // const handleClickDataBase = () => {
    //     window.location.href = 'https://nous.matatastudio.com/';
    // }
    // 点击搭建
    // const handleClickBuild = () => {
    //     window.location.href = 'https://nous.matatastudio.com/';
    // }
    // 点击教程
    const handleClickTips = () => {
        localStorage.setItem('routerMeunId', 'tutorialsLibrary')
        window.location.href = window.location.origin
        // window.location.href = 'https://nous.matatastudio.com/';
    }
    const onUserLoggedOut = () => {

    }
    const onLoadingStarted = () => {

    }
    const onLoadingFinished = () => {

    }
    useEffect(() => {
        // Override tabindex.
        // Has no dependencies as it needs to run for every re-render.
        // fss = fs
    });
    // 添加新作品
    const handleClickNew = () => {
        // if the project is dirty, and user owns the project, we will autosave.
        // but if they are not logged in and can't save, user should consider
        // downloading or logging in first.
        // Note that if user is logged in and editing someone else's project,
        // they'll lose their work.
        try {
            // let readyToReplaceProject = true;
            // if (loginState && projectChanged) {
            //     // 验证项目名称
            //     const isValid = this.workMenuItemRef.checkProjectName();
            //     if (!isValid) return;
            //     // 自动保存
            //     const isSuccess = await this.workMenuItemRef.triggerSave();
            //     // 如果保存成功，直接新建作品
            //     if (isSuccess) {
            //         this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
            //         return;
            //     }
            //     // 如果保存失败，弹出提示框
            //     setTimeout(() => {
            //         readyToReplaceProject = this.props.confirmReadyToReplaceProject(
            //             this.props.intl.formatMessage(sharedMessages.replaceProjectWarning)
            //         );
            //         if (readyToReplaceProject) {
            //             this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
            //         }
            //     }, 1000);
            //     return;
            // }
            // readyToReplaceProject = this.props.confirmReadyToReplaceProject(
            //     this.props.intl.formatMessage(sharedMessages.replaceProjectWarning)
            // );
            // if (readyToReplaceProject) {
            //     this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
            // }
            // this.props.onRequestCloseFile();
            // // Clear all blocks in monitor.
            // this.props.vm.runtime.clearMonitor();
        } catch (error) {
            console.log('新建作品失败');
        }
    }
    const intl = useIntl();
    return (
        <Box
            className="menuBar"
        >
            <div className="mainMenu">
                <div className="fileGroup">
                    {/* logo */}
                    {isWebview() ? <div>
                        <img
                            alt="Matatalab"
                            className="scratchBack"
                            draggable={false}
                            src={backIcon}
                            onClick={handleClickLogo}
                        />
                    </div> : <div className="menuBarItem">
                            <img
                                alt="Matatalab"
                                className="scratchLogo"
                                draggable={false}
                                src={logo}
                                onClick={handleClickLogo}
                            />
                        </div>}


                    {/* 选择语言 */}
                    <LanguageMenuItem />

                    {/* 新建文件 */}
                    <FileMenuItem
                        fileMenuOpen={false}
                        canRemix={true}
                        isRtl={false}
                        canSave={true}
                        canCreateCopy={true}
                        onClickFile={handleClickFile}
                        onRequestCloseFile={handleRequestCloseFile}
                        onClickSave={handleClickSave}
                        onClickSaveAsCopy={handleClickSaveAsCopy}
                        handleClickNew={() => {
                            // 处理点击新建的逻辑
                        }}
                        handleClickRemix={() => {
                            // 处理点击重新混合的逻辑
                        }}
                        fs={fs}
                    />
                </div>
                {/* 嵌入式机器学习AI */}
                <AImenuItem/>
                {/* <div
                    className="menuBarItem"
                    onClick={handleClickAIProject}
                >
                    <img
                        className="helpIcon"
                        src={embeddedIcon}
                    />
                    {intl.formatMessage({
                        id: "meun-item-aiproject",
                        defaultMessage: "TinyML"
                    })}
                </div> */}
                {/* 数据库 */}
                {/*<div*/}
                {/*    className="menuBarItem"*/}
                {/*    onClick={handleClickDataBase}*/}
                {/*>*/}
                {/*    <img*/}
                {/*        className="helpIcon"*/}
                {/*        src={databaseIcon}*/}
                {/*        width="17px"*/}
                {/*        height="17px"*/}
                {/*    />*/}
                {/*    数据库*/}
                {/*</div>*/}

                {/* 修改作品标题 */}
                <WorkMenuItem
                    fs={fs}
                    // ref={this.workMenuItemRef}
                    canEditTitle={true}
                // authorUsername={this.props.authorUsername}
                // authorThumbnailUrl={this.props.authorThumbnailUrl}
                // authorId={this.props.authorId}
                // onUploadSuccess={this.props.onUploadSuccess}
                // onProjectTelemetryEvent={this.props.onProjectTelemetryEvent}
                // loginState={this.props.loginState}// 登录状态
                // onSaveError={this.props.onSaveError}
                // 手动触发保存
                // onSaveProject={this.props.onSaveProject}
                />
            </div>

            {/* 搭建 */}
            {/*<div*/}
            {/*    className="menuBarItem"*/}
            {/*    onClick={handleClickBuild}*/}
            {/*>*/}
            {/*    <img*/}
            {/*        className="helpIcon"*/}
            {/*        src={buildIcon}*/}
            {/*        width='17px'*/}
            {/*    />*/}
            {/*    搭建*/}
            {/*</div>*/}

            {/* 教程 */}
            {/* <div
                className="menuBarItem"
                onClick={handleClickTips}
            >
                <img
                    className="helpIcon"
                    src={helpIcon}
                />
                {intl.formatMessage({
                    id: "meun-item-tutorials",
                    defaultMessage: "Tutorials"
                })}
            </div> */}

            {/* 工具箱 */}
            {/* toolbox */}
            <ToolboxMenuItem />


            {/* 帮助 */}
            <AccountCancelationModal
                onUserLoggedOut={onUserLoggedOut}
                onLoadingStarted={onLoadingStarted}
                onLoadingFinished={onLoadingFinished}
                ref={accountCancelationModalRef}
            />
            {/* <HelpMenuItem */}
            {/*     loginState={this.props.loginState}// 登录状态 */}
            {/*     isRtl={this.props.isRtl} */}
            {/*     onAccountCancellationModal={this.handleAccountCancellationModal} */}
            {/* /> */}

            {/* 登录我的账户信息 */}
            <div className="accountInfoGroup">
                <AccountNav fs={fs} />
            </div>
            {/* {aboutButton} */}
        </Box>
    );
};
const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    const loginState = state.scratchGui.userState.loginState;
}
const mapDispatchToProps = dispatch => ({
    // setUserLoginMode: mode => dispatch(setUserLoginMode(mode))
});
// export default compose(
//     injectIntl,
//     connect(mapStateToProps, mapDispatchToProps)
// )(MenuBar);
export default MenuBar;
